"use client";
import { useEffect, useState } from "react";
import ResourceGrid from "./PressList";
import { getWhiteList } from "@/lib/ApiClient";
import Loader from "@/components/Loader";
export default function Resources() {
  const [whitePaperArr, setWhitePaperArr] = useState([]);
  const [baseURL, setBaseUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchWhitePaperList = async () => {
    try {
      setLoading(true);
      const data = await getWhiteList(1, 10);
      setBaseUrl(data?.baseUrl);
      setWhitePaperArr(data?.items);
    } catch (err: any) {
      console.log(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWhitePaperList();
  }, []);

  return (
    <>
      <section className="bg-[#ffffff] py-[70px] lg:py-[120px] text-[#00040b]">
        <div className="mx-auto flex max-w-[2500px] w-[calc(100vw-10%)] flex-col gap-[60px] px-5">
          <div className="flex flex-col items-start gap-6 text-left">
            <span className="text-sm font-semibold uppercase tracking-[0.4em] text-[#636363]">
              Resources
            </span>
            <h2 className="font-[500] max-w-[30ch] clash-font text-[clamp(2.25rem,1.35rem+2.2vw,3.65rem)] leading-[110%]">
              <span>An Extensive Collection Of </span>
              <span className="text-[#225bd4]">
                Technology Information Specific
              </span>
              <span> To Your Needs</span>
            </h2>
            <p className="text-base text-[#636363] md:text-lg">
              Powered by our own proprietary technology solutions, we provide a
              go-to source for tech, digital culture and cutting-edge technology
              content for our dedicated and influential audience around the
              globe.
            </p>
          </div>

          <div className="h-px w-full bg-[#ecf0f6]" />
          <div className="w-full">
            {loading ? (
              <div className="flex justify-center items-center w-full py-10">
                <Loader size={80} />
              </div>
            ) : whitePaperArr?.length > 0 ? (
              <ResourceGrid items={whitePaperArr} baseUrl={baseURL} />
            ) : (
              <p>No Whitepaper Found</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
